import React from 'react';

interface NumberPillInputProps {
  value: number | undefined;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  ariaLabel?: string;
  disabled?: boolean;
  disablePresets?: boolean;
  presetValues?: number[];
}

const NumberPillInput: React.FC<NumberPillInputProps> = ({ 
  value, 
  onChange, 
  min, 
  max, 
  ariaLabel, 
  disabled,
  disablePresets = false,
  presetValues = [0, 3, 6]
}) => {
  const handleDecrement = () => {
    if (disabled || value === undefined) return;
    if (min !== undefined && value <= min) return;
    onChange(value - 1);
  };

  const handleIncrement = () => {
    if (disabled || value === undefined) return;
    if (max !== undefined && value >= max) return;
    onChange(value + 1);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    const v = e.target.value === '' ? undefined : parseInt(e.target.value);
    if (v !== undefined && !isNaN(v)) onChange(v);
  };

  const handlePresetClick = (preset: number) => {
    if (disabled) return;
    onChange(preset);
  };

  if (!disablePresets && value === undefined) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        borderRadius: 999, 
        overflow: 'hidden', 
        border: '1px solid #444', 
        background: '#111', 
        height: 36, 
        opacity: disabled ? 0.5 : 1 
      }}>
        {presetValues.map((preset, index) => (
          <React.Fragment key={preset}>
            <button
              type="button"
              onClick={() => handlePresetClick(preset)}
              disabled={disabled}
              style={{
                height: 36,
                padding: '0 7px',
                fontSize: 16,
                background: 'none',
                color: '#fff',
                border: 'none',
                borderRight: index < presetValues.length ? '1px solid #444' : undefined,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer',
              }}
            >
              {preset}
            </button>
          </React.Fragment>
        ))}
        <button
          type="button"
          onClick={() => handlePresetClick(presetValues[presetValues.length - 1] + 1)}
          disabled={disabled}
          style={{
            height: 36,
            padding: '0 7px',
            fontSize: 16,
            background: 'none',
            color: '#fff',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            userSelect: 'none',
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        >
          ...
        </button>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', borderRadius: 999, overflow: 'hidden', border: '1px solid #444', background: '#111', width: 100, height: 36, opacity: disabled ? 0.5 : 1 }}>
      <button
        type="button"
        aria-label={ariaLabel ? `Decrement ${ariaLabel}` : 'Decrement'}
        onClick={handleDecrement}
        disabled={disabled || value === undefined || (min !== undefined && value <= min)}
        style={{
          width: 36,
          height: 36,
          fontSize: 22,
          background: 'none',
          color: '#fff',
          border: 'none',
          borderRight: '1px solid #444',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          userSelect: 'none',
          opacity: disabled || value === undefined || (min !== undefined && value <= min) ? 0.5 : 1,
          cursor: disabled || value === undefined || (min !== undefined && value <= min) ? 'not-allowed' : 'pointer',
        }}
      >
        –
      </button>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={value ?? ''}
        onChange={handleInputChange}
        min={min}
        max={max}
        aria-label={ariaLabel}
        disabled={disabled}
        style={{
          width: 28,
          textAlign: 'center',
          fontSize: 18,
          border: 'none',
          background: 'transparent',
          color: '#fff',
          outline: 'none',
          opacity: disabled ? 0.5 : 1,
        }}
      />
      <button
        type="button"
        aria-label={ariaLabel ? `Increment ${ariaLabel}` : 'Increment'}
        onClick={handleIncrement}
        disabled={disabled || value === undefined || (max !== undefined && value >= max)}
        style={{
          width: 36,
          height: 36,
          fontSize: 22,
          background: 'none',
          color: '#fff',
          border: 'none',
          borderLeft: '1px solid #444',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          userSelect: 'none',
          opacity: disabled || value === undefined || (max !== undefined && value >= max) ? 0.5 : 1,
          cursor: disabled || value === undefined || (max !== undefined && value >= max) ? 'not-allowed' : 'pointer',
        }}
      >
        +
      </button>
    </div>
  );
};

export default NumberPillInput; 